import React from 'react';
import { Card, Badge } from 'antd';
import { CalendarOutlined } from '@ant-design/icons';

const UpcomingEvents = () => {
  const events = [
    { 
      name: 'Tech Conference 2024', 
      date: '15 Mars 2024', 
      status: 'success',
      organizer: 'Digital Events Corp',
      attendees: 250
    },
    { 
      name: 'Startup Summit', 
      date: '22 Mars 2024', 
      status: 'warning',
      organizer: 'Innovation Hub',
      attendees: 180
    },
    { 
      name: 'Digital Workshop', 
      date: '30 Mars 2024', 
      status: 'primary',
      organizer: 'Tech Academy',
      attendees: 120
    }
  ];

  return (
    <Card
      className="h-full col-span-1 lg:col-span-2"
      title={
        <div className="flex items-center gap-2">
          <CalendarOutlined className="text-primary-500" />
          <span className="font-heading">Événements à venir</span>
        </div>
      }
    >
      <div className="space-y-4">
        {events.map((event, index) => (
          <div 
            key={index} 
            className="flex flex-col sm:flex-row items-start sm:items-center justify-between p-4 border border-neutral-200 rounded-xl hover:border-primary-300 transition-colors gap-4"
          >
            <div className="flex items-center gap-3">
              <div className={`w-2 h-2 rounded-full bg-${event.status}-500`} />
              <div className="flex flex-col">
                <span className="font-medium text-neutral-800">{event.name}</span>
                <span className="text-sm text-neutral-500">{event.date}</span>
                <span className="text-xs text-neutral-400">
                  Organisé par {event.organizer} • {event.attendees} participants
                </span>
              </div>
            </div>
            <Badge 
              status={event.status} 
              text={event.status === 'success' ? 'Confirmé' : event.status === 'warning' ? 'En attente' : 'À venir'}
            />
          </div>
        ))}
      </div>
    </Card>
  );
};

export default UpcomingEvents;
